import React from 'react';
import ReactDOM from 'react-dom';

const FileUpload = React.createClass({
    render: function () {
        return (
            <div>
                <input type="filepicker" data-fp-apikey="A9dIrmaYxQk6D8Df5N5tkz"
                       onChange={(e) => console.log(e)} />
            </div>
        );
    }
});

export default FileUpload;


/** WEBPACK FOOTER **
 ** ./src/mocks/FileUpload.js
 **/